/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ReferralRecipientInput
 */
export interface ReferralRecipientInput {
    /**
     * Preferred recipient identifier from the provider directory.
     * @type {string}
     * @memberof ReferralRecipientInput
     */
    provider_id?: string;
    /**
     * Deprecated legacy internal recipient organization id. Use provider_id for new callers.
     * @type {number}
     * @memberof ReferralRecipientInput
     * @deprecated
     */
    organization_id?: number;
    /**
     * Deprecated legacy internal recipient facility id. Use provider_id for new callers.
     * @type {number}
     * @memberof ReferralRecipientInput
     * @deprecated
     */
    facility_id?: number;
    /**
     * 
     * @type {string}
     * @memberof ReferralRecipientInput
     */
    email?: string;
}

/**
 * Check if a given object implements the ReferralRecipientInput interface.
 */
export function instanceOfReferralRecipientInput(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ReferralRecipientInputFromJSON(json: any): ReferralRecipientInput {
    return ReferralRecipientInputFromJSONTyped(json, false);
}

export function ReferralRecipientInputFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReferralRecipientInput {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'provider_id': !exists(json, 'provider_id') ? undefined : json['provider_id'],
        'organization_id': !exists(json, 'organization_id') ? undefined : json['organization_id'],
        'facility_id': !exists(json, 'facility_id') ? undefined : json['facility_id'],
        'email': !exists(json, 'email') ? undefined : json['email'],
    };
}

export function ReferralRecipientInputToJSON(value?: ReferralRecipientInput | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'provider_id': value.provider_id,
        'organization_id': value.organization_id,
        'facility_id': value.facility_id,
        'email': value.email,
    };
}

